/* eslint-disable arrow-body-style */
import React, { useEffect } from 'react';

import { Box, Image, Link } from '@chakra-ui/react';
import { Button, Download } from '@mesh.ai/rabbit';

import MSTeamsLogoIcon from 'assets/assetsV1/illustrations/MSTeamsLogoIcon.png';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyMedium, TextHeader2 } from 'uiToolkitV1/Typography';

import { GuideSection } from './guideSection';
import { InstallationSection } from './installationSection';

export const PLUGIN_TYPE = { FINCH: 'FINCH', MERGE: 'MERGE' };

const MSTeamsAppUrl = 'https://teams.microsoft.com/l/app/72882807-95fe-48d0-95f2-1dee861c4c09?source=store-copy-link';

const Header = () => {
  return (
    <Box display="flex" gap={3} alignItems="center">
      <Box p="20px">
        <Image src={MSTeamsLogoIcon} boxSize="80px" />
      </Box>

      <Box display="flex" flexDir="column">
        <TextHeader2 mb={1} bold>
          Microsoft Teams App
        </TextHeader2>
        <TextBodyMedium color="text.g2" mb={3}>
          Manage goals and tasks without ever leaving teams
        </TextBodyMedium>
        <Link href={MSTeamsAppUrl} target="_blank">
          <Button iconLeft={Download}>Install</Button>
        </Link>
      </Box>
    </Box>
  );
};

const MSTeamsPlugin = () => {
  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        source: 'Company-settings-MS Teams',
      },
    });
  }, []);

  return (
    <PaperWithShadow display="flex" p={4} flexDir="column" gap="12px">
      <Header />

      <GuideSection />

      <InstallationSection />
    </PaperWithShadow>
  );
};

export default MSTeamsPlugin;
